<template>
  <div>
    <cookie-banner-view />
    <header-view />
    <router-view />
    <widget-sidebar-view />
    <widget-footer-view />
  </div>
</template>

<script>
import WidgetSidebarView from '@/components/WidgetSidebarView.vue'
import WidgetFooterView from '@/components/WidgetFooterView.vue'
import CookieBannerView from '@/components/CookieBannerView.vue'
import HeaderView from '@/components/HeaderView.vue'


export default {
  name: 'default-layout',
  components: {
    HeaderView, WidgetSidebarView, WidgetFooterView, CookieBannerView
  }
}
</script>